package com.swetdot.swetgram.ui.premium

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.swetdot.swetgram.data.premium.PremiumRepository
import com.swetdot.swetgram.domain.PremiumAccess
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class PremiumUiState(
    val entitlement: PremiumAccess? = null,
    val loadedOnce: Boolean = false,
    val error: String? = null,
    val savingPreference: Boolean = false,
)

class PremiumViewModel(private val premium: PremiumRepository) : ViewModel() {
    private val _state = MutableStateFlow(PremiumUiState())
    val state: StateFlow<PremiumUiState> = _state.asStateFlow()

    init { refresh() }

    fun refresh() {
        viewModelScope.launch {
            try {
                _state.value = PremiumUiState(
                    entitlement = premium.get(),
                    loadedOnce = true,
                )
            } catch (cancellation: CancellationException) {
                throw cancellation
            } catch (_: Throwable) {
                _state.value = _state.value.copy(
                    loadedOnce = true,
                    error = "Could not load Swetgram Black.",
                )
            }
        }
    }

    fun dismissError() {
        _state.value = _state.value.copy(error = null)
    }

    fun setBadgeVisible(visible: Boolean) {
        val previous = _state.value.entitlement
        if (previous?.active != true || _state.value.savingPreference) return
        _state.value = _state.value.copy(
            entitlement = previous.copy(badgeVisible = visible),
            savingPreference = true,
            error = null,
        )
        viewModelScope.launch {
            try {
                _state.value = _state.value.copy(
                    entitlement = premium.updateBadgeVisibility(visible),
                    savingPreference = false,
                )
            } catch (cancellation: CancellationException) {
                throw cancellation
            } catch (_: Throwable) {
                _state.value = _state.value.copy(
                    entitlement = previous,
                    savingPreference = false,
                    error = "Could not update the Black badge.",
                )
            }
        }
    }
}
